import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseRestService } from "./base-rest.service";

@Injectable({
    providedIn: 'root'
})
export class IdentityService extends BaseRestService {

    readonly CONTENT_API_URL: string = environment.apiUri + '/identity';

    download(id: string): Observable<any> {
        let headers = new HttpHeaders();
        headers.append("Content-Type", "application/octet-stream");
        return this.httpClient.get(this.CONTENT_API_URL + "/download?identifier=" + encodeURIComponent(id),
            { headers: headers, responseType: 'blob' });

    }

    upload(file): Observable<any> {
        let headers = new HttpHeaders();
        headers.append("Content-Type", " multipart/form-data");
        return this.httpClient.post(this.CONTENT_API_URL + "/upload", file,
            { headers: headers });
    }

}
